import { render } from "./Slider.vue?vue&type=template&id=4111ad0b&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=4111ad0b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4111ad0b"

export default script